<!-- <app-loader [isBusy]="isBusy">
<ng-template> -->
<div class="modal-header">
    <h4 class="modal-title">{{ 'User Manual' | translate }}</h4>
    <button class="close" type="button" aria-label="Close" (click)="activeModal.close(true)">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<app-loader [isBusy]="isBusy">
    <ng-template>
        <div class="modal-body">
            <form class="p-3" [formGroup]="form">
                <div class="row">
                    <div class="col-4">
                        <form-dropdown
                            formControlName="parentCategoryId"
                            labelText="{{ 'Category' | translate }}"
                            [displayValue]="'name'"
                            [codeListValues]="categories"></form-dropdown>
                    </div>
                    <div class="col-4">
                        <form-dropdown
                            formControlName="helpCategoryId"
                            labelText="{{ 'Sub Category' | translate }}"
                            [displayValue]="'name'"
                            [codeListValues]="subCategories"></form-dropdown>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <form-textbox formControlName="name" labelText="{{ 'Name' | translate }}"></form-textbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <form-textbox formControlName="nameEN" labelText="{{ 'Name EN' | translate }}"></form-textbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <form-textbox
                            formControlName="description"
                            labelText="{{ 'Description' | translate }}"></form-textbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <form-textbox
                            formControlName="descriptionEN"
                            labelText="{{ 'Description EN' | translate }}"></form-textbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <form-textbox
                            formControlName="youtubeURL"
                            labelText="{{ 'YouTube Video URL' | translate }}"
                            placeholder="https://www.youtube.com/watch?v=..."></form-textbox>
                    </div>
                </div>
                @if (getYouTubeEmbedUrl()) {
                    <div class="row">
                        <div class="col">
                            <label class="form-label">{{ 'Preview' | translate }}</label>
                            <div class="youtube-preview">
                                <iframe
                                    width="100%"
                                    height="200"
                                    frameborder="0"
                                    loading="lazy"
                                    referrerpolicy="strict-origin-when-cross-origin"
                                    allowfullscreen
                                    [src]="getYouTubeEmbedUrl()"></iframe>
                            </div>
                        </div>
                    </div>
                }
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <kendo-fileselect
                            formControlName="helpAttachments"
                            [restrictions]="attachmentFileUploadRestrictions"
                            [multiple]="true"
                            (select)="fileSelected($event)">
                            <ng-template kendoFileSelectFileTemplate let-files>
                                <div class="mb-2">
                                    <div class="file-name">{{ files[0].name }}</div>
                                    <div class="file-size small text-muted">Size: {{ bytesToKB(files[0].size) }}</div>
                                </div>
                                <button
                                    class="btn btn-sm btn-danger remove-button"
                                    kendoButton
                                    (click)="removeAttachment(files[0].uid, files[0].id)">
                                    <fa-icon [icon]="['fas', 'trash']"></fa-icon>
                                    &nbsp;&nbsp;{{ 'Remove' | translate }}
                                </button>
                            </ng-template>
                        </kendo-fileselect>
                    </div>
                </div>
            </form>
        </div>

        <div class="modal-footer">
            <button class="btn btn-sm btn-primary mr-2" [disabled]="!form.valid" (click)="addDocument()">
                <fa-icon [icon]="['fas', 'check']"></fa-icon>
                &nbsp;&nbsp;{{ 'Save' | translate }}
            </button>
            <button class="btn btn-sm btn-secondary" (click)="activeModal.close(true)">
                <fa-icon [icon]="['fas', 'times']"></fa-icon>
                &nbsp;&nbsp;{{ 'Cancel' | translate }}
            </button>
        </div>
    </ng-template>
</app-loader>
